export const USER_ROLE = {
    INSTRUCTOR: "",
    STUDENT: "Student",
    ADMIN: "Admin"  
}